import { useMemo } from 'react';
import { buildTimezones, TimeZone } from '@/lib/timezones';

export default function useTimeZones(): TimeZone[] {
  const currentTime = new Date();
  // Optimization: only generate timezones once per hour, or once per component's life
  return useMemo(() => buildTimezones(currentTime), [currentTime.getHours()]);
}
